import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CrownStrikethroughFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="crownStrikethroughFilled" ref={ref} {...props}>
    <path d="M15.45,5.92l-10.11,10a.75.75,0,0,1-.53.22l-.2,0a.75.75,0,0,1-.52-.54l-1.75-7a.75.75,0,0,1,1.13-.81L6.28,9.54,8,5.19a.76.76,0,0,1,.58-.46.77.77,0,0,1,.7.27L11.5,7.72l2.9-2.87a.75.75,0,0,1,1.06,0A.75.75,0,0,1,15.45,5.92Zm6.22,2.61-2,8.45v0c-.26,2.06-5.39,2.29-7.63,2.29a20.84,20.84,0,0,1-5.59-.63L3.6,21.47a.76.76,0,0,1-1.07,0,.75.75,0,0,1,0-1.06L20.41,2.54A.75.75,0,0,1,21.47,3.6L17.1,8l.62,1.57,2.82-1.81a.75.75,0,0,1,1.13.8Zm-3.56,8.28c-.47-.55-3.13-1.49-6.11-1.49a15.77,15.77,0,0,0-2.45.2l-1.9,1.9a22.4,22.4,0,0,0,4.35.37C15.66,17.79,17.68,17.19,18.11,16.81Z" />
  </Icon>
)) as IconWithRender;

CrownStrikethroughFilledIcon.displayName = 'CrownStrikethroughFilledIcon';
CrownStrikethroughFilledIcon.renderIcon = (props) => (
  <CrownStrikethroughFilledIcon {...props} />
);
export default CrownStrikethroughFilledIcon;
